import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import flow from 'lodash/flow';
import values from 'lodash/values';

import { HistoryEvent } from '@api/types';
import { getPreparedName } from '@react/constants/historyEvent/preparation/prepareNames';
import { getLocalizedKind } from '@react/constants/historyEvent/localization/kindLocalization';
import { getParams } from '@react/constants/historyEvent/preparation/paramsUpdater';
import { getAction } from '@react/constants/historyEvent/preparation/prepareAction';
import { getLocalizedAction } from '@react/constants/historyEvent/localization/actionLocalization';

export function nameStartsWith(event: { attributes: { name: string } }, ...searchStrings: string[]): boolean {
  return searchStrings.some(searchString => event.attributes.name.startsWith(searchString));
}

export function getHistoryAppId({ attributes }: HistoryEvent): string {
  const { parameters } = attributes;
  const id = parameters.mobile_app?.default_store_app_id;

  return id || parameters.default_store_app_id || values(parameters.store_app_ids)[0];
}

export function isUninstallEvent(event: HistoryEvent): boolean {
  return nameStartsWith(event, 'dashboard:mobile_apps/uninstall_settings');
}

function renderDisplayName(name: string, noEventPrefixOmit?) {
  if (name === 'enabled') {
    return t('partner-setup.enabled.label');
  }

  if (!name || isEmpty(name)) {
    return '';
  }

  const nameArray = name.split('_');
  const numberPart = String(parseInt(name, 10));

  if ((!noEventPrefixOmit && nameArray[0] === 'event') || nameArray[0] === 'is') {
    nameArray.shift();
  }

  if (name === 'sessions_disabled') {
    return "Don't Send Sessions";
  }

  name = nameArray.map(n => capitalize(n)).join(' ');

  if (name.indexOf(numberPart) === 0) {
    name = name.slice(0, numberPart.length) + capitalize(name.slice(numberPart.length));
  }

  return name;
}

export function getPartnerName(partner) {
  if (!partner || isEmpty(partner)) {
    return '';
  }

  if (partner.partner_display_name) {
    return partner.partner_display_name;
  }

  return renderDisplayName(partner.name);
}

export const prepareAction = flow(getAction, getLocalizedAction);

export function prepareEventParam(event: HistoryEvent): HistoryEvent {
  return {
    ...event,
    attributes: {
      ...event.attributes,
      name: getPreparedName(event),
      action: prepareAction(event),
      kind: getLocalizedKind(event.attributes.kind),
      parameters: getParams(event),
    },
  };
}
